module.exports = "﻿﻿<div class=\"middle-box text-center loginscreen animated fadeInDown\">\r\n    <div class=\"center-login\">\r\n        <img class=\"logo\" src=\"" + require("../../../../wwwroot/images/B2B Logo.png") + "\" alt=\"B2B Tenders Logo\">\r\n        <p>Email validation in process...</p>\r\n        <small>If validation does not complete within 5 seconds, please <a (click)=\"sendValidationToken()\">click here</a></small>\r\n    </div>\r\n</div>";


//////////////////
// WEBPACK FOOTER
// ./Client/app/views/registration/validate.email.component.html
// module id = 1217
// module chunks = 0